import { render } from "./PreviewRilascioTutela.vue?vue&type=template&id=192cf8f8&scoped=true"
import script from "./PreviewRilascioTutela.vue?vue&type=script&lang=js"
export * from "./PreviewRilascioTutela.vue?vue&type=script&lang=js"

import "./PreviewRilascioTutela.vue?vue&type=style&index=0&id=192cf8f8&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192cf8f8"]])

export default __exports__